import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { plato_api_model_correlations_tags_path } from '@/modules/routes';
import QueryKeys from '@/utils/QueryKeys';
import { CorrelationCategory, ModelCorrelation, ModelCorrelationsResponse } from '../types';

// Module-level so the empty case keeps a stable identity across renders.
const NO_CATEGORIES: CorrelationCategory[] = [];
const NO_CORRELATIONS: ModelCorrelation[] = [];

interface UseModelCorrelationsParams {
  enabled: boolean;
  modelId: number;
  modelType: string;
}

// The slide builder calls this alongside TagManagerTable; the shared query key dedupes them to one request.
// Unpacks the envelope so callers don't restate `data?.data ?? []` — meta.categories drives the Category
// filter, which lists every standards category rather than only those present on this item.
export default function useModelCorrelations({ enabled, modelId, modelType }: UseModelCorrelationsParams) {
  const query = useQuery({
    enabled,
    queryFn: () => axios.get<ModelCorrelationsResponse>(
      plato_api_model_correlations_tags_path(),
      { params: { model_id: modelId, model_type: modelType } },
    ).then(res => res.data),
    queryKey: [QueryKeys.ModelCorrelations, modelType, modelId],
  });

  return {
    ...query,
    // `meta` is always present from the API; the `?.` guards the slide builder's tests, which
    // blanket-mock axios with a URL-agnostic `{ data: { data: [] } }`. Removing it fails 17 of them.
    categories: query.data?.meta?.categories ?? NO_CATEGORIES,
    correlations: query.data?.data ?? NO_CORRELATIONS,
  };
}
